import { Box, Button, Link } from '@chakra-ui/react'
import React from 'react'

interface ConsiderationLinkProps {
  children: React.ReactNode
  href?: string
  onClick?: () => void
  target?: string
  [key: string]: any
}

export const ConsiderationLink = ({
  children,
  href,
  onClick,
  target,
  ...props
}: ConsiderationLinkProps) => {
  const buttonProps = {
    size: 'sm' as const,
    color: 'primary',
    borderRadius: '4px',
    bg: '#F6F7FE',
    display: 'flex',
    minHeight: '32px',
    padding: '4px 8px',
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    m: '0',
    ...props
  }

  if (href) {
    return (
      <Link
        href={href}
        _hover={{ textDecoration: 'none' }}
        display="inline-block"
        width="fit-content"
        target={target}
      >
        <Button {...buttonProps}>{children}</Button>
      </Link>
    )
  }

  return (
    <Button {...buttonProps} onClick={onClick}>
      {children}
    </Button>
  )
}
